import httpClient from '../httpClient';

const ajaxTableStructure = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/structure/?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const createStructure = async (data) => {
  return await httpClient.post(`structure/`, data);
}

const updateStructure = async (id, data) => {
  return await httpClient.put(`structure/${id}/`, data);
}

const deleteStructure = async (id) => {
  return await httpClient.delete(`structure/${id}/`);
}

const getStructure = async (id) => {
  return await httpClient.get(`structure/${id}/`);
}

const getStructureTypes = async () => {
  return await httpClient.get(`structure/types/`);
};

export {
  ajaxTableStructure,
  createStructure,
  updateStructure,
  deleteStructure,
  getStructure,
  getStructureTypes,
};
